import React from 'react';
import { Tag, Tooltip } from 'antd';
import { WBS_LAYER_HINTS } from '@/utils/est3WbsLayers';

const LAYER_COLORS: Record<string, string> = {
  PROJECT: 'geekblue',
  UNIT: 'blue',
  AREA: 'cyan',
  BLOCK: 'green',
  MODULE: 'orange',
  PACKAGE: 'purple',
};

export interface Est3WbsLayerTagProps {
  layerCode?: string | null;
  showHint?: boolean;
}

export const Est3WbsLayerTag: React.FC<Est3WbsLayerTagProps> = ({ layerCode, showHint = true }) => {
  if (!layerCode) return <>—</>;
  const tag = (
    <Tag color={LAYER_COLORS[layerCode] || 'default'} style={{ margin: 0 }}>
      {layerCode}
    </Tag>
  );
  if (!showHint) return tag;
  const hint = WBS_LAYER_HINTS[layerCode];
  return hint ? <Tooltip title={hint}>{tag}</Tooltip> : tag;
};
